import { ClientStateStatus } from './client-state-status';

export const initialState: ClientStateState = {
  status: ClientStateStatus.Initial,
};

export class ClientStateState {
  status: ClientStateStatus;
}
